module.exports = __webpack_public_path__ + "img/PLUS.789532bb.svg";